export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10338.6f72b66a.jpg";